// Sistema de traducciones para la aplicación S3 Browser
export const translations = {
  es: {
    // Navegación
    'nav.home': 'Explorador',
    'nav.admin': 'Admin',
    'nav.logout': 'Cerrar sesión',
    
    // Navegación y buckets
    'buckets.title': 'Explorador de S3',
    'buckets.subtitle': 'Selecciona un bucket para explorar',
    'buckets.back': 'Volver a los buckets',
    'buckets.empty': 'No hay buckets disponibles',
    
    // Filtros
    'filter.title': 'Filtros',
    'filter.placeholder': 'Filtrar archivos y carpetas...',
    'filter.bucketPlaceholder': 'Filtrar buckets...',
    'filter.clear': 'Limpiar filtro',
    'filter.noResults': 'No se encontraron resultados para el filtro',
    'filter.showingResults': 'Mostrando {{count}} de {{total}} buckets',
    'filter.noBucketsFound': 'No se encontraron buckets que coincidan con "{{searchText}}"',
    
    // Estados de carga
    'loading.buckets': 'Cargando buckets...',
    'loading.loading': 'Cargando...',
    
    // Navegación
    'navigation.back': '.. (Volver)',
    'navigation.backTooltip': 'Volver al directorio anterior',
    
    // Admin filtros
    'admin.filter.user': 'Filtrar por usuario',
    'admin.filter.path': 'Filtrar por ruta/prefijo',
    'admin.filter.userPlaceholder': 'Nombre de usuario...',
    'admin.filter.pathPlaceholder': 'Ruta o prefijo...',
    
    // Botones y acciones
    'files.actions': 'Acciones',
    'actions.upload': 'Subir',
    'actions.download': 'Descargar',
    'actions.delete': 'Eliminar',
    'actions.deleteFolder': 'Eliminar carpeta',
    'actions.rename': 'Renombrar',
    'actions.createFolder': 'Nueva carpeta',
    'actions.refresh': 'Actualizar',
    'actions.selectFiles': 'Seleccionar archivos',
    'actions.selectFolder': 'Seleccionar carpeta',
    'actions.save': 'Guardar',
    'actions.cancel': 'Cancelar',
    'actions.proxyLink': 'Enlace seguro',
    'actions.publicLink': 'URL pública',
    'actions.copyProxyLink': 'Copiar enlace seguro',
    'actions.copyPublicLink': 'Copiar URL pública',
    'actions.edit': 'Editar',
    'actions.open': 'Abrir',
    
    // Vista
    'view.cards': 'Tarjetas',
    'view.list': 'Lista',
    'view.selectMode': 'Seleccionar múltiple',
    'view.exitSelectMode': 'Salir de selección',
    
    // Navegación y exploración
    'navigation.exploreFiles': 'Explora archivos y carpetas • Haz clic en las carpetas para navegar',
    'navigation.foldersBreadcrumb': 'Carpetas',
    'navigation.filesBreadcrumb': 'Archivos',
    'navigation.viewLabel': 'Vista',
    
    // Selección múltiple
    'selection.enable': '☑️ Seleccionar múltiple',
    'selection.cancel': '❌ Cancelar selección',
    'selection.selectAll': 'Seleccionar todo',
    'selection.clearSelection': 'Limpiar selección',
    
    // Archivos y carpetas
    'files.empty': 'Esta carpeta está vacía',
    'files.size': 'Tamaño',
    'files.modified': 'Modificado',
    'files.name': 'Nombre',
    'files.type': 'Tipo',
    'files.folderName': 'Nombre de la nueva carpeta:',
    
    // Mensajes de error
    'errors.downloadFile': 'Error al descargar archivo',
    'errors.renameFile': 'Error al renombrar el archivo',
    'errors.renameFolder': 'Error al renombrar la carpeta',
    'errors.deleteFolder': 'Error al eliminar la carpeta',
    'errors.deleteItems': 'Error al eliminar elementos',
    'errors.openFile': 'Error al abrir archivo',
    'errors.loadData': 'Error al cargar datos',
    
    // Subida de archivos
    'upload.dragdrop': 'Arrastra archivos o carpetas aquí, o selecciona:',
    'upload.dragdropEnhanced': 'Arrastra archivos o carpetas aquí, o:',
    'upload.processing': 'Procesando archivos...',
    'upload.processingElements': 'Procesando elementos...',
    'upload.noValidFiles': 'No se encontraron archivos válidos.',
    'upload.uploading': 'Subiendo {count} archivo(s)...',
    'upload.completed': 'Subida completada.',
    'upload.error': 'Error al subir archivos: {message}',
    'upload.dragDropError': 'Error durante la subida: {message}',
    'upload.folderNotSupported': 'Tu navegador no soporta la selección de carpetas. Usa Chrome, Edge o Firefox moderno.',
    'upload.folderHint': 'Selecciona una carpeta completa con todos sus archivos y subcarpetas',
    
    // Confirmaciones
    'confirm.deleteFile': '¿Eliminar el archivo {name}?',
    'confirm.deleteFolder': '¿Eliminar la carpeta "{name}" y todo su contenido?',
    'confirm.deleteSelected': '¿Eliminar {count} elemento(s) seleccionado(s)?',
    
    // Mensajes
    'messages.fileRenamed': 'Archivo renombrado exitosamente',
    'messages.folderRenamed': 'Carpeta renombrada exitosamente',
    'messages.folderDeleted': 'Carpeta eliminada exitosamente. {count} objetos eliminados.',
    'messages.folderCreated': 'Carpeta creada exitosamente',
    
    // Errores
    'errors.fileNotFound': 'Archivo no encontrado',
    'errors.uploadFailed': 'Error al subir archivos',
    'errors.deleteFailed': 'Error al eliminar',
    'errors.renameFailed': 'Error al renombrar',
    'errors.createFolderFailed': 'Error al crear carpeta',
    'errors.loadFailed': 'Error al cargar',
    'errors.permissionDenied': 'Permisos insuficientes',
    
    // Usuario
    'user.defaultName': 'Usuario',
    
    // Idiomas
    'language.spanish': 'Español',
    'language.catalan': 'Català',
    'language.english': 'English',
    
    // Admin traducciones adicionales
    'admin.title': 'Administración de Permisos',
    'admin.accessDenied': 'Se requiere el rol admin para acceder a esta página.',
    'admin.debugInfo': 'Información de debug:',
    'admin.currentRoles': 'Roles actuales:',
    'admin.rolesNote': 'Nota: Los roles deben estar configurados en Keycloak bajo realm_access → roles',
    'admin.userIdPlaceholder': 'ID de usuario',
    'admin.pathPlaceholder': 'Ruta / prefijo',
    'admin.currentPermissions': 'Permisos Actuales',
    'admin.noPermissions': 'No hay permisos configurados',
    'admin.add': 'Agregar Permiso',
    'admin.permissions.read': 'Lectura',
    'admin.permissions.write': 'Escritura',
    'admin.permissions.admin': 'Administrador',
    'admin.help.pathFormat': 'Formato de paths',
    'admin.createdDate': 'Fecha de creación',
    'admin.expiryDate': 'Fecha de caducidad (opcional)',
    'admin.notes': 'Notas (opcional)',
    'admin.list.notes': 'Notas',
    'admin.notesPlaceholder': 'Notas o comentarios sobre este permiso...',
    'admin.status.expired': 'CADUCADO',
    'admin.status.expiringSoon': 'CADUCA PRONTO',
    'admin.created': 'Creado',
    'admin.expires': 'Caduca',

    // Filtros de caducidad
    'admin.filter.expiry': 'Filtrar por caducidad',
    'admin.filter.expiry.all': 'Todos',
    'admin.filter.expiry.expired': 'Caducados',
    'admin.filter.expiry.expiringSoon': 'Caducan pronto',
    'admin.filter.expiry.valid': 'Válidos',
    
    // Ordenamiento
    'admin.sort.by': 'Ordenar por',
    'admin.sort.user': 'Usuario',
    'admin.sort.path': 'Ruta',
    'admin.sort.expiry': 'Fecha caducidad',
    'admin.sort.created': 'Fecha creación',
    'admin.sort.order': 'Orden',
    'admin.sort.asc': 'Ascendente',
    'admin.sort.desc': 'Descendente',
    
    // Edición
    'admin.edit.save': 'Guardar cambios',
    'admin.edit.cancel': 'Cancelar',
    'admin.edit.clickToEdit': 'Clic para editar',
    
    // Importación CSV
    'admin.csv.title': 'Importación CSV',
    'admin.csv.file': 'Archivo CSV',
    'admin.csv.operation': 'Operación',
    'admin.csv.import': 'Importar permisos',
    'admin.csv.delete': 'Eliminar permisos',
    'admin.csv.format': 'Formato CSV esperado',
    'admin.csv.formatDescription': 'usuario,bucket/path,permiso,fecha_caducidad,notas',
    'admin.csv.fieldUser': 'usuario: email del usuario (obligatorio)',
    'admin.csv.fieldPath': 'bucket/path: ruta del bucket/carpeta (obligatorio, se añade "/" al inicio automáticamente)',
    'admin.csv.fieldPermission': 'permiso: read o write (obligatorio)',
    'admin.csv.fieldExpiry': 'fecha_caducidad: YYYY-MM-DD (opcional)',
    'admin.csv.fieldNotes': 'notas: comentarios adicionales (opcional)',
    'admin.csv.downloadTemplate': 'Descargar Plantilla',
    'admin.csv.importButton': 'Importar',
    'admin.csv.deleteButton': 'Eliminar',
    'admin.csv.processing': 'Procesando...',
    'admin.csv.results': 'Resultados',
    'admin.csv.processed': 'Procesados',
    'admin.csv.successful': 'Exitosos',
    'admin.csv.errors': 'Errores',
    'admin.csv.errorsList': 'Errores',
    
    // Backup y Restauración
    'admin.backup.title': 'Backup y Restauración',
    'admin.backup.create': 'Crear Backup',
    'admin.backup.creating': 'Creando backup...',
    'admin.backup.success': 'Backup creado exitosamente',
    'admin.backup.error': 'Error creando backup',
    'admin.backup.noPermissions': 'No hay permisos para respaldar',
    'admin.backup.available': 'Backups Disponibles',
    'admin.backup.loading': 'Cargando backups...',
    'admin.backup.noBackups': 'No hay backups disponibles',
    'admin.backup.filename': 'Archivo',
    'admin.backup.date': 'Fecha',
    'admin.backup.size': 'Tamaño',
    'admin.backup.restore': 'Restaurar',
    'admin.backup.restoreConfirm': 'Confirmar Restauración',
    'admin.backup.restoreWarning': '⚠️ ADVERTENCIA: Esta operación eliminará TODOS los permisos actuales y los reemplazará con los del backup seleccionado.',
    'admin.backup.restoreQuestion': '¿Estás seguro de que quieres continuar?',
    'admin.backup.restoreCancel': 'Cancelar',
    'admin.backup.restoreExecute': 'Sí, Restaurar',
    'admin.backup.restoring': 'Restaurando...',
    'admin.backup.restoreSuccess': 'Restauración completada',
    'admin.backup.restoreError': 'Error en restauración',
    'admin.backup.results': 'Resultados de Restauración',
    'admin.backup.deleted': 'Permisos eliminados',
    'admin.backup.restored': 'Permisos restaurados',
    'admin.backup.deleteErrors': 'Errores al eliminar',
    'admin.backup.restoreErrors': 'Errores al restaurar',
    'admin.backup.createTitle': 'Crear Backup',
    'admin.backup.createDescription': 'Crea una copia de seguridad de todos los permisos actuales',
    'admin.backup.backupCount': 'Permisos respaldados',
    'admin.backup.backupLocation': 'Ubicación',
    'admin.backup.downloadLocal': 'Crear copia local adicional',
    'admin.backup.downloadLocalDesc': 'Descarga una copia del backup actual a tu ordenador como respaldo adicional',
    'admin.backup.connectivityError': 'Verifique la conectividad con S3 y los permisos del bucket',
    'admin.backup.restoreOptions': 'Opciones de Restauración',
    'admin.backup.extendExpired': 'Extender fechas de caducidad vencidas',
    'admin.backup.extendExpiredDesc': 'Los permisos con fechas caducadas serán extendidos automáticamente',
    'admin.backup.extendDays': 'Extender por',
    'admin.backup.days': 'días',
    'admin.backup.restoringWarning': 'Esta operación puede tardar unos minutos. No cierres la ventana.',
    'admin.backup.selectedBackup': 'Backup seleccionado'
  },
  
  ca: {
    // Navegación
    'nav.home': 'Explorador',
    'nav.admin': 'Admin',
    'nav.logout': 'Tancar sessió',
    
    // Navegación y buckets
    'buckets.title': 'Explorador d\'S3',
    'buckets.subtitle': 'Selecciona un bucket per explorar',
    'buckets.back': 'Tornar als buckets',
    'buckets.empty': 'No hi ha buckets disponibles',
    
    // Filtros
    'filter.title': 'Filtres',
    'filter.placeholder': 'Filtrar arxius i carpetes...',
    'filter.bucketPlaceholder': 'Filtrar buckets...',
    'filter.clear': 'Netejar filtre',
    'filter.noResults': 'No s\'han trobat resultats pel filtre',
    'filter.showingResults': 'Mostrant {{count}} de {{total}} buckets',
    'filter.noBucketsFound': 'No s\'han trobat buckets que coincideixin amb "{{searchText}}"',
    
    // Estats de càrrega
    'loading.buckets': 'Carregant buckets...',
    'loading.loading': 'Carregant...',
    
    // Navegació
    'navigation.back': '.. (Tornar)',
    'navigation.backTooltip': 'Tornar al directori anterior',
    
    // Admin filtros
    'admin.filter.user': 'Filtrar per usuari',
    'admin.filter.path': 'Filtrar per ruta/prefix',
    'admin.filter.userPlaceholder': 'Nom d\'usuari...',
    'admin.filter.pathPlaceholder': 'Ruta o prefix...',
    
    // Botones y acciones
    'files.actions': 'Accions',
    'actions.upload': 'Pujar',
    'actions.download': 'Descarregar',
    'actions.delete': 'Eliminar',
    'actions.deleteFolder': 'Eliminar carpeta',
    'actions.rename': 'Reanomenar',
    'actions.createFolder': 'Nova carpeta',
    'actions.refresh': 'Actualitzar',
    'actions.selectFiles': 'Seleccionar arxius',
    'actions.selectFolder': 'Seleccionar carpeta',
    'actions.save': 'Desar',
    'actions.cancel': 'Cancel·lar',
    'actions.proxyLink': 'Enllaç segur',
    'actions.publicLink': 'URL pública',
    'actions.copyProxyLink': 'Copiar enllaç segur',
    'actions.copyPublicLink': 'Copiar URL pública',
    'actions.edit': 'Editar',
    'actions.open': 'Obrir',
    
    // Vista
    'view.cards': 'Targetes',
    'view.list': 'Llista',
    'view.selectMode': 'Seleccionar múltiple',
    'view.exitSelectMode': 'Sortir de selecció',
    
    // Navegación y exploración
    'navigation.exploreFiles': 'Explora arxius i carpetes • Fes clic a les carpetes per navegar',
    'navigation.foldersBreadcrumb': 'Carpetes',
    'navigation.filesBreadcrumb': 'Arxius',
    'navigation.viewLabel': 'Vista',
    
    // Selección múltiple
    'selection.enable': '☑️ Seleccionar múltiple',
    'selection.cancel': '❌ Cancel·lar selecció',
    'selection.selectAll': 'Seleccionar tot',
    'selection.clearSelection': 'Netejar selecció',
    
    // Archivos y carpetas
    'files.empty': 'Aquesta carpeta està buida',
    'files.size': 'Mida',
    'files.modified': 'Modificat',
    'files.name': 'Nom',
    'files.type': 'Tipus',
    'files.folderName': 'Nom de la nova carpeta:',
    
    // Missatges d'error
    'errors.downloadFile': 'Error en descarregar arxiu',
    'errors.renameFile': 'Error en reanomenar l\'arxiu',
    'errors.renameFolder': 'Error en reanomenar la carpeta',
    'errors.deleteFolder': 'Error en eliminar la carpeta',
    'errors.deleteItems': 'Error en eliminar elements',
    'errors.openFile': 'Error en obrir arxiu',
    'errors.loadData': 'Error en carregar dades',
    
    // Subida de archivos
    'upload.dragdrop': 'Arrossega arxius o carpetes aquí, o selecciona:',
    'upload.dragdropEnhanced': 'Arrossega arxius o carpetes aquí, o:',
    'upload.processing': 'Processant arxius...',
    'upload.processingElements': 'Processant elements...',
    'upload.noValidFiles': 'No s\'han trobat arxius vàlids.',
    'upload.uploading': 'Pujant {count} arxiu(s)...',
    'upload.completed': 'Pujada completada.',
    'upload.error': 'Error al pujar arxius: {message}',
    'upload.dragDropError': 'Error durant la pujada: {message}',
    'upload.folderNotSupported': 'El teu navegador no suporta la selecció de carpetes. Usa Chrome, Edge o Firefox modern.',
    'upload.folderHint': 'Selecciona una carpeta completa amb tots els seus arxius i subcarpetes',
    
    // Confirmaciones
    'confirm.deleteFile': 'Eliminar l\'arxiu {name}?',
    'confirm.deleteFolder': 'Eliminar la carpeta "{name}" i tot el seu contingut?',
    'confirm.deleteSelected': 'Eliminar {count} element(s) seleccionat(s)?',
    
    // Mensajes
    'messages.fileRenamed': 'Arxiu reanomenat amb èxit',
    'messages.folderRenamed': 'Carpeta reanomenada amb èxit',
    'messages.folderDeleted': 'Carpeta eliminada amb èxit. {count} objectes eliminats.',
    'messages.folderCreated': 'Carpeta creada amb èxit',
    
    // Errores
    'errors.fileNotFound': 'Arxiu no trobat',
    'errors.uploadFailed': 'Error al pujar arxius',
    'errors.deleteFailed': 'Error al eliminar',
    'errors.renameFailed': 'Error al reanomenar',
    'errors.createFolderFailed': 'Error al crear carpeta',
    'errors.loadFailed': 'Error al carregar',
    'errors.permissionDenied': 'Permisos insuficients',
    
    // Usuario
    'user.defaultName': 'Usuari',
    
    // Idiomas
    'language.spanish': 'Español',
    'language.catalan': 'Català',
    'language.english': 'English',
    
    // Admin traducciones adicionales en catalán
    'admin.title': 'Administració de Permisos',
    'admin.accessDenied': 'Es requereix el rol admin per accedir a aquesta pàgina.',
    'admin.debugInfo': 'Informació de debug:',
    'admin.currentRoles': 'Rols actuals:',
    'admin.rolesNote': 'Nota: Els rols han d\'estar configurats a Keycloak sota realm_access → roles',
    'admin.userIdPlaceholder': 'ID d\'usuari',
    'admin.pathPlaceholder': 'Ruta / prefix',
    'admin.currentPermissions': 'Permisos Actuels',
    'admin.noPermissions': 'No hi ha permisos configurats',
    'admin.add': 'Afegir Permís',
    'admin.permissions.read': 'Lectura',
    'admin.permissions.write': 'Escriptura',
    'admin.permissions.admin': 'Administrador',
    'admin.help.pathFormat': 'Format de paths',
    'admin.createdDate': 'Data de creació',
    'admin.expiryDate': 'Data de caducitat (opcional)',
    'admin.notes': 'Notes (opcional)',
    'admin.list.notes': 'Notes',
    'admin.notesPlaceholder': 'Notes o comentaris sobre aquest permís...',
    'admin.status.expired': 'CADUCAT',
    'admin.status.expiringSoon': 'CADUCA AVIAT',
    'admin.created': 'Creat',
    'admin.expires': 'Caduca',
    
    // Filtros de caducidad
    'admin.filter.expiry': 'Filtrar per caducitat',
    'admin.filter.expiry.all': 'Tots',
    'admin.filter.expiry.expired': 'Caducats',
    'admin.filter.expiry.expiringSoon': 'Caduquen aviat',
    'admin.filter.expiry.valid': 'Vàlids',
    
    // Ordenamiento
    'admin.sort.by': 'Ordenar per',
    'admin.sort.user': 'Usuari',
    'admin.sort.path': 'Ruta',
    'admin.sort.expiry': 'Data caducitat',
    'admin.sort.created': 'Data creació',
    'admin.sort.order': 'Ordre',
    'admin.sort.asc': 'Ascendent',
    'admin.sort.desc': 'Descendent',
    
    // Edición
    'admin.edit.save': 'Guardar canvis',
    'admin.edit.cancel': 'Cancel·lar',
    'admin.edit.clickToEdit': 'Clic per editar',
    
    // Importación CSV
    'admin.csv.title': 'Importació CSV',
    'admin.csv.file': 'Arxiu CSV',
    'admin.csv.operation': 'Operació',
    'admin.csv.import': 'Importar permisos',
    'admin.csv.delete': 'Eliminar permisos',
    'admin.csv.format': 'Format CSV esperat',
    'admin.csv.formatDescription': 'usuari,bucket/path,permís,data_caducitat,notes',
    'admin.csv.fieldUser': 'usuari: email de l\'usuari (obligatori)',
    'admin.csv.fieldPath': 'bucket/path: ruta del bucket/carpeta (obligatori, s\'afegeix "/" a l\'inici automàticament)',
    'admin.csv.fieldPermission': 'permís: read o write (obligatori)',
    'admin.csv.fieldExpiry': 'data_caducitat: YYYY-MM-DD (opcional)',
    'admin.csv.fieldNotes': 'notes: comentaris addicionals (opcional)',
    'admin.csv.downloadTemplate': 'Descarregar Plantilla',
    'admin.csv.importButton': 'Importar',
    'admin.csv.deleteButton': 'Eliminar',
    'admin.csv.processing': 'Processant...',
    'admin.csv.results': 'Resultats',
    'admin.csv.processed': 'Processats',
    'admin.csv.successful': 'Exitosos',
    'admin.csv.errors': 'Errors',
    'admin.csv.errorsList': 'Errors',
    
    // Backup y Restauración
    'admin.backup.title': 'Backup i Restauració',
    'admin.backup.create': 'Crear Backup',
    'admin.backup.creating': 'Creant backup...',
    'admin.backup.success': 'Backup creat amb èxit',
    'admin.backup.error': 'Error creant backup',
    'admin.backup.noPermissions': 'No hi ha permisos per respaldar',
    'admin.backup.available': 'Backups Disponibles',
    'admin.backup.loading': 'Carregant backups...',
    'admin.backup.noBackups': 'No hi ha backups disponibles',
    'admin.backup.filename': 'Arxiu',
    'admin.backup.date': 'Data',
    'admin.backup.size': 'Mida',
    'admin.backup.restore': 'Restaurar',
    'admin.backup.restoreConfirm': 'Confirmar Restauració',
    'admin.backup.restoreWarning': '⚠️ ADVERTÈNCIA: Aquesta operació eliminarà TOTS els permisos actuals i els reemplaçarà amb els del backup seleccionat.',
    'admin.backup.restoreQuestion': 'Estàs segur que vols continuar?',
    'admin.backup.restoreCancel': 'Cancel·lar',
    'admin.backup.restoreExecute': 'Sí, Restaurar',
    'admin.backup.restoring': 'Restaurant...',
    'admin.backup.restoreSuccess': 'Restauració completada',
    'admin.backup.restoreError': 'Error en restauració',
    'admin.backup.results': 'Resultats de Restauració',
    'admin.backup.deleted': 'Permisos eliminats',
    'admin.backup.restored': 'Permisos restaurats',
    'admin.backup.deleteErrors': 'Errors en eliminar',
    'admin.backup.restoreErrors': 'Errors en restaurar',
    'admin.backup.createTitle': 'Crear Backup',
    'admin.backup.createDescription': 'Crea una còpia de seguretat de tots els permisos actuals',
    'admin.backup.backupCount': 'Permisos respaldats',
    'admin.backup.backupLocation': 'Ubicació',
    'admin.backup.downloadLocal': 'Crear còpia local addicional',
    'admin.backup.downloadLocalDesc': 'Descarrega una còpia del backup actual al teu ordinador com a respald addicional',
    'admin.backup.connectivityError': 'Verifica la connectivitat amb S3 i els permisos del bucket',
    'admin.backup.restoreOptions': 'Opcions de Restauració',
    'admin.backup.extendExpired': 'Estendre dates de caducitat vençudes',
    'admin.backup.extendExpiredDesc': 'Els permisos amb dates caducades seran estesos automàticament',
    'admin.backup.extendDays': 'Estendre per',
    'admin.backup.days': 'dies',
    'admin.backup.restoringWarning': 'Aquesta operació pot trigar uns minuts. No tanquis la finestra.',
    'admin.backup.selectedBackup': 'Backup seleccionat'
  },
  
  en: {
    // Navegación
    'nav.home': 'Explorer',
    'nav.admin': 'Admin',
    'nav.logout': 'Logout',
    
    // Navegación y buckets
    'buckets.title': 'S3 Explorer',
    'buckets.subtitle': 'Select a bucket to explore',
    'buckets.back': 'Back to buckets',
    'buckets.empty': 'No buckets available',
    
    // Filtros
    'filter.title': 'Filters',
    'filter.placeholder': 'Filter files and folders...',
    'filter.bucketPlaceholder': 'Filter buckets...',
    'filter.clear': 'Clear filter',
    'filter.noResults': 'No results found for the filter',
    'filter.showingResults': 'Showing {{count}} of {{total}} buckets',
    'filter.noBucketsFound': 'No buckets found matching "{{searchText}}"',
    
    // Loading states
    'loading.buckets': 'Loading buckets...',
    'loading.loading': 'Loading...',
    
    // Navigation
    'navigation.back': '.. (Back)',
    'navigation.backTooltip': 'Go back to previous directory',
    
    // Admin filtros
    'admin.filter.user': 'Filter by user',
    'admin.filter.path': 'Filter by path/prefix',
    'admin.filter.userPlaceholder': 'Username...',
    'admin.filter.pathPlaceholder': 'Path or prefix...',
    
    // Botones y acciones
    'files.actions': 'Actions',
    'actions.upload': 'Upload',
    'actions.download': 'Download',
    'actions.delete': 'Delete',
    'actions.deleteFolder': 'Delete folder',
    'actions.rename': 'Rename',
    'actions.createFolder': 'New folder',
    'actions.refresh': 'Refresh',
    'actions.selectFiles': 'Select files',
    'actions.selectFolder': 'Select folder',
    'actions.save': 'Save',
    'actions.cancel': 'Cancel',
    'actions.proxyLink': 'Secure link',
    'actions.publicLink': 'Public URL',
    'actions.copyProxyLink': 'Copy secure link',
    'actions.copyPublicLink': 'Copy public URL',
    'actions.edit': 'Edit',
    'actions.open': 'Open',
    
    // Vista
    'view.cards': 'Cards',
    'view.list': 'List',
    'view.selectMode': 'Multiple select',
    'view.exitSelectMode': 'Exit selection',
    
    // Navigation and exploration
    'navigation.exploreFiles': 'Explore files and folders • Click on folders to navigate',
    'navigation.foldersBreadcrumb': 'Folders',
    'navigation.filesBreadcrumb': 'Files',
    'navigation.viewLabel': 'View',
    
    // Multiple selection
    'selection.enable': '☑️ Multiple select',
    'selection.cancel': '❌ Cancel selection',
    'selection.selectAll': 'Select all',
    'selection.clearSelection': 'Clear selection',
    
    // Archivos y carpetas
    'files.empty': 'This folder is empty',
    'files.size': 'Size',
    'files.modified': 'Modified',
    'files.name': 'Name',
    'files.type': 'Type',
    'files.folderName': 'New folder name:',
    
    // Mensajes de error
    'errors.downloadFile': 'Error downloading file',
    'errors.renameFile': 'Error renaming file',
    'errors.renameFolder': 'Error renaming folder',
    'errors.deleteFolder': 'Error deleting folder',
    'errors.deleteItems': 'Error deleting items',
    'errors.openFile': 'Error opening file',
    'errors.loadData': 'Error loading data',
    
    // Subida de archivos
    'upload.dragdrop': 'Drag files or folders here, or select:',
    'upload.dragdropEnhanced': 'Drag files or folders here, or:',
    'upload.processing': 'Processing files...',
    'upload.processingElements': 'Processing elements...',
    'upload.noValidFiles': 'No valid files found.',
    'upload.uploading': 'Uploading {count} file(s)...',
    'upload.completed': 'Upload completed.',
    'upload.error': 'Error uploading files: {message}',
    'upload.dragDropError': 'Error during upload: {message}',
    'upload.folderNotSupported': 'Your browser does not support folder selection. Use Chrome, Edge or modern Firefox.',
    'upload.folderHint': 'Select a complete folder with all its files and subfolders',
    
    // Confirmaciones
    'confirm.deleteFile': 'Delete the file {name}?',
    'confirm.deleteFolder': 'Delete the folder "{name}" and all its content?',
    'confirm.deleteSelected': 'Delete {count} selected item(s)?',
    
    // Mensajes
    'messages.fileRenamed': 'File renamed successfully',
    'messages.folderRenamed': 'Folder renamed successfully',
    'messages.folderDeleted': 'Folder deleted successfully. {count} objects deleted.',
    'messages.folderCreated': 'Folder created successfully',
    
    // Errores
    'errors.fileNotFound': 'File not found',
    'errors.uploadFailed': 'Error uploading files',
    'errors.deleteFailed': 'Error deleting',
    'errors.renameFailed': 'Error renaming',
    'errors.createFolderFailed': 'Error creating folder',
    'errors.loadFailed': 'Error loading',
    'errors.permissionDenied': 'Insufficient permissions',
    
    // Usuario
    'user.defaultName': 'User',
    
    // Idiomas
    'language.spanish': 'Español',
    'language.catalan': 'Català',
    'language.english': 'English',
    
    // Admin traducciones adicionales en inglés
    'admin.title': 'Permissions Management',
    'admin.accessDenied': 'Admin role is required to access this page.',
    'admin.debugInfo': 'Debug information:',
    'admin.currentRoles': 'Current roles:',
    'admin.rolesNote': 'Note: Roles must be configured in Keycloak under realm_access → roles',
    'admin.userIdPlaceholder': 'User ID',
    'admin.pathPlaceholder': 'Path / prefix',
    'admin.currentPermissions': 'Current Permissions',
    'admin.noPermissions': 'No permissions configured',
    'admin.add': 'Add Permission',
    'admin.permissions.read': 'Read',
    'admin.permissions.write': 'Write',
    'admin.permissions.admin': 'Admin',
    'admin.help.pathFormat': 'Path format',
    'admin.createdDate': 'Creation date',
    'admin.expiryDate': 'Expiry date (optional)',
    'admin.notes': 'Notes (optional)',
    'admin.list.notes': 'Notes',
    'admin.notesPlaceholder': 'Notes or comments about this permission...',
    'admin.status.expired': 'EXPIRED',
    'admin.status.expiringSoon': 'EXPIRING SOON',
    'admin.created': 'Created',
    'admin.expires': 'Expires',
    
    // Filtros de caducidad
    'admin.filter.expiry': 'Filter by expiry',
    'admin.filter.expiry.all': 'All',
    'admin.filter.expiry.expired': 'Expired',
    'admin.filter.expiry.expiringSoon': 'Expiring soon',
    'admin.filter.expiry.valid': 'Valid',
    
    // Ordenamiento
    'admin.sort.by': 'Sort by',
    'admin.sort.user': 'User',
    'admin.sort.path': 'Path',
    'admin.sort.expiry': 'Expiry date',
    'admin.sort.created': 'Creation date',
    'admin.sort.order': 'Order',
    'admin.sort.asc': 'Ascending',
    'admin.sort.desc': 'Descending',
    
    // Edición
    'admin.edit.save': 'Save changes',
    'admin.edit.cancel': 'Cancel',
    'admin.edit.clickToEdit': 'Click to edit',
    
    // Importación CSV
    'admin.csv.title': 'CSV Import',
    'admin.csv.file': 'CSV File',
    'admin.csv.operation': 'Operation',
    'admin.csv.import': 'Import permissions',
    'admin.csv.delete': 'Delete permissions',
    'admin.csv.format': 'Expected CSV format',
    'admin.csv.formatDescription': 'user,bucket/path,permission,expiry_date,notes',
    'admin.csv.fieldUser': 'user: user email (required)',
    'admin.csv.fieldPath': 'bucket/path: bucket/folder path (required, "/" automatically added at beginning)',
    'admin.csv.fieldPermission': 'permission: read or write (required)',
    'admin.csv.fieldExpiry': 'expiry_date: YYYY-MM-DD (optional)',
    'admin.csv.fieldNotes': 'notes: additional comments (optional)',
    'admin.csv.downloadTemplate': 'Download Template',
    'admin.csv.importButton': 'Import',
    'admin.csv.deleteButton': 'Delete',
    'admin.csv.processing': 'Processing...',
    'admin.csv.results': 'Results',
    'admin.csv.processed': 'Processed',
    'admin.csv.successful': 'Successful',
    'admin.csv.errors': 'Errors',
    'admin.csv.errorsList': 'Errors',
    
    // Backup and Restore
    'admin.backup.title': 'Backup and Restore',
    'admin.backup.create': 'Create Backup',
    'admin.backup.creating': 'Creating backup...',
    'admin.backup.success': 'Backup created successfully',
    'admin.backup.error': 'Error creating backup',
    'admin.backup.noPermissions': 'No permissions to backup',
    'admin.backup.available': 'Available Backups',
    'admin.backup.loading': 'Loading backups...',
    'admin.backup.noBackups': 'No backups available',
    'admin.backup.filename': 'File',
    'admin.backup.date': 'Date',
    'admin.backup.size': 'Size',
    'admin.backup.restore': 'Restore',
    'admin.backup.restoreConfirm': 'Confirm Restore',
    'admin.backup.restoreWarning': '⚠️ WARNING: This operation will delete ALL current permissions and replace them with those from the selected backup.',
    'admin.backup.restoreQuestion': 'Are you sure you want to continue?',
    'admin.backup.restoreCancel': 'Cancel',
    'admin.backup.restoreExecute': 'Yes, Restore',
    'admin.backup.restoring': 'Restoring...',
    'admin.backup.restoreSuccess': 'Restore completed',
    'admin.backup.restoreError': 'Error in restore',
    'admin.backup.results': 'Restore Results',
    'admin.backup.deleted': 'Permissions deleted',
    'admin.backup.restored': 'Permissions restored',
    'admin.backup.deleteErrors': 'Deletion errors',
    'admin.backup.restoreErrors': 'Restore errors',
    'admin.backup.createTitle': 'Create Backup',
    'admin.backup.createDescription': 'Create a backup of all current permissions',
    'admin.backup.backupCount': 'Permissions backed up',
    'admin.backup.backupLocation': 'Location',
    'admin.backup.downloadLocal': 'Create additional local copy',
    'admin.backup.downloadLocalDesc': 'Download a copy of the current backup to your computer as additional backup',
    'admin.backup.connectivityError': 'Check S3 connectivity and bucket permissions',
    'admin.backup.restoreOptions': 'Restore Options',
    'admin.backup.extendExpired': 'Extend expired expiry dates',
    'admin.backup.extendExpiredDesc': 'Permissions with expired dates will be automatically extended',
    'admin.backup.extendDays': 'Extend by',
    'admin.backup.days': 'days',
    'admin.backup.restoringWarning': 'This operation may take a few minutes. Do not close the window.',
    'admin.backup.selectedBackup': 'Selected backup'
  }
};

// Hook personalizado para las traducciones
export const useTranslation = (language = 'es') => {
  const t = (key, params = {}) => {
    const translation = translations[language]?.[key] || translations['es'][key] || key;
    
    // Reemplazar parámetros en el texto si los hay
    return Object.keys(params).reduce((text, param) => {
      return text.replace(new RegExp(`{${param}}`, 'g'), params[param]);
    }, translation);
  };
  
  return { t };
};
